<template>
  <div>
    <div class="main-header" :class="{ 'has-footer': hasFooter }">
      <!-- 在路由地址为首页统日/月/年订单详情的时候隐藏面包屑导航 -->
      <a-breadcrumb v-if="!$route.meta.hideBread">
        <a-breadcrumb-item :key="index" v-for="(item, index) in breadcrumb">
          <router-link :to="{ name: item.name }">
            {{ item.title }}
          </router-link>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="main-header-heading">
        <div class="main-header-heading-left">
          <span class="main-header-heading-title">{{ title || routeTitle }}</span>
        </div>
        <div class="main-header-heading-extra">
          <slot name="extra"></slot>
        </div>
      </div>
      <div class="main-header-footer" v-if="hasFooter">
        <a-tabs :tabBarStyle="{ margin: 0 }" :activeKey="tabActiveKey" @change="handleTabChange">
          <a-tab-pane :key="item.key" :tab="item.tab" v-for="item in tabs"></a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div class="main-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainContainer',

  props: {
    title: String,
    tabs: Array,
    tabActiveKey: [String, Number],
  },

  computed: {
    routeTitle() {
      const matched = this.$route.matched;
      const length = matched.length;
      return length === 0 ? null : matched[length - 1].meta.title;
    },

    routeBreadcrumb() {
      return this.$route.matched.map(item => {
        return {
          name: item.name,
          title: item.meta.title,
        };
      });
    },

    breadcrumb() {
      return this.routeBreadcrumb;
    },

    hasFooter() {
      return !!this.tabs && this.tabs.length > 0;
    },
  },

  methods: {
    handleTabChange(key) {
      this.$emit('update:tabActiveKey', key);
    },
  },
};
</script>

<style scoped lang="less">
.main-header {
  padding: 12px 24px 14px;
  background: #fff;

  &.has-footer {
    padding-bottom: 0;
  }
}

.main-header-heading {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-header-heading-left,
.main-header-heading-extra {
  margin: 4px 0;
}

.main-header-heading-title {
  margin-right: 12px;
  text-overflow: ellipsis;
  font-size: 20px;
  line-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  color: rgba(#000, 0.85);
  font-weight: 500;
}

.main-header-footer {
  margin-top: 16px;
}

.main-content {
  margin: 24px 24px 0;
}
</style>
